const chains = [];
chains.push({ _operation: 'getPaymentSystemTransactionCategoryStatementDetailsById', api: '/payment-system-transaction-category-statement-details/:objectId', defaultData: [], httpVerb: 'get' });
export default chains;
